import apiClient from './apiClient';

/**
 * Alle Benutzer laden
 */
export const getAllBenutzer = async (params = {}) => {
  const response = await apiClient.get('/benutzer', { params });
  return response.data;
};

/**
 * Einzelnen Benutzer laden
 */
export const getBenutzerById = async (id) => {
  const response = await apiClient.get(`/benutzer/${id}`);
  return response.data;
};

/**
 * Neuen Benutzer erstellen
 */
export const createBenutzer = async (data) => {
  const response = await apiClient.post('/benutzer', data);
  return response.data;
};

/**
 * Benutzer aktualisieren
 */
export const updateBenutzer = async (id, data) => {
  const response = await apiClient.put(`/benutzer/${id}`, data);
  return response.data;
};

/**
 * Benutzer löschen
 */
export const deleteBenutzer = async (id) => {
  const response = await apiClient.delete(`/benutzer/${id}`);
  return response.data;
};

/**
 * Berechtigungen speichern
 */
export const updatePermissions = async (id, permissions) => {
  const response = await apiClient.put(`/benutzer/${id}/permissions`, { permissions });
  return response.data;
};

/**
 * Passwort zurücksetzen
 */
export const resetPassword = async (id, neuesPasswort) => {
  const response = await apiClient.post(`/benutzer/${id}/reset-password`, { neuesPasswort });
  return response.data;
};

/**
 * Einladungs-E-Mail erneut senden
 */
export const resendInvite = async (id) => {
  const response = await apiClient.post(`/benutzer/${id}/resend-invite`);
  return response.data;
};

/**
 * Eigene Berechtigungen laden
 */
export const getMyPermissions = async () => {
  const response = await apiClient.get('/benutzer/me/permissions');
  return response.data;
};

export default {
  getAllBenutzer,
  getBenutzerById,
  createBenutzer,
  updateBenutzer,
  deleteBenutzer,
  updatePermissions,
  resetPassword,
  resendInvite,
  getMyPermissions
};
